import * as extendUtils from '../../../utils/object/extend.utils';
import {cbssportsStagingConfig} from '../cbssports';
import {PrismConfigOptions} from '../environment-variables.interface';

export const sportslineStagingConfig: PrismConfigOptions = extendUtils.deepExtend({}, [cbssportsStagingConfig, {
  environmentName: "Sportsline Staging Environment",
  ionicEnvName: 'staging',
  siteId: 2,
  hubApi: 'https://qa-cms.sportsline.com',
  loginPageClass: 'sportslineLoginPageBackground',
  loginFormLogo: './assets/logos/sportsline-logo.png',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/sportsline/staging.config.ts